import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  QueryList,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { AppResource } from 'src/app/app.resource';
import { environment } from 'src/environments/environment';
import { PopUpInfoVM } from '../../models/components/popupinfoVm';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { getMetropoleCapPictureName } from '../../helpers/metropole-helper.service';

@Component({
  selector: 'app-info-bottom',
  templateUrl: './info-bottom.component.html',
  styles: '',
  encapsulation: ViewEncapsulation.None
})
export class InfoBottomComponent implements AfterViewInit {
  @Input() popUpInfo!: PopUpInfoVM;

  @ViewChildren('textEvent') textEvents!: QueryList<ElementRef>;
  showDialog: boolean = false;

  @Input() className: string = '';
  @Input() path!: PathType;
  pathType = PathType;

  get brand() {
    return environment.brand;
  }

  imgSrc!: string;
  resource: any;
  imgInfo!: string;

  constructor(resources: AppResource) {
    this.resource = resources['resource'];
    this.imgInfo = `assets/${this.brand}/Images/Devis/InfoPhone.svg`;

    this.className =
      this.path === this.pathType.HOUSING_CRETEIL ||
      this.path === this.pathType.HOUSING_GRENOBLE ||
      this.path === this.pathType.HOUSING_MARSEILLE
        ? 'img-cap'
        : 'img-cap-2';
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.textEvents.forEach((textEl: ElementRef) => {
        const spans = textEl.nativeElement.querySelectorAll('span');
        spans.forEach((span: HTMLElement) => {
          span.style.cursor = 'pointer';
          span.addEventListener('click', () => this.openModal());
        });
      });
    }, 0);
  }

  openModal() {
    this.showDialog = true;
  }

  getPath(): string | undefined {
    return getMetropoleCapPictureName(this.path);
  }
}
